import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { ButtonVariant } from "@/constants/button/button"
import React from "react"

interface ConfirmationModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  actionButtonText: string
  dialogTitle: string
  dialogSubtitle: string
  onConfirm: () => void
  variant?: ButtonVariant
  actionButtonVariant?: ButtonVariant
  children?: React.ReactNode
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onOpenChange,
  actionButtonText,
  dialogTitle,
  dialogSubtitle,
  onConfirm,
  variant = ButtonVariant.DEFAULT,
  actionButtonVariant,
  children,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{dialogTitle}</AlertDialogTitle>
          <AlertDialogDescription>{dialogSubtitle}</AlertDialogDescription>
        </AlertDialogHeader>
        {children}
        <AlertDialogFooter className="mt-4">
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="hover:opacity-90"
            variant={actionButtonVariant ?? variant}
            onClick={() => {
              onConfirm()
              onOpenChange(false)
            }}
          >
            {actionButtonText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
